import { render, staticRenderFns } from "./DcInside.vue?vue&type=template&id=1752db20&scoped=true"
import script from "./DcInside.vue?vue&type=script&lang=js"
export * from "./DcInside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1752db20",
  null
  
)

export default component.exports